import { h } from "preact";
import { useState, useEffect } from "preact/hooks";
import { Box, Button, Grid, Stack, Typography } from "@mui/material";

import { makeStyles } from "@mui/styles";
import NumberField from "../Common/NumberField";
import PriceBreakdown2 from "../Common/PriceBreakdown2";

const useStyles = makeStyles((theme) => ({}));

export default function DealPrice({ upperState, setUpperState, mode }) {
	const classes = useStyles();

	const [state, setState] = useState({ ...upperState });

	const handleChange = (event) => {
		console.log("handleChange")
		setState({ ...state, [event.target.name]: event.target.value });
	};
	useEffect(() => {
		console.log("price changed", state.price);
	}, [state.price])
	const handleSubmit = () => {
		const requestOptions = {
			method: "POST",
			headers: { "Content-Type": "application/json" },

			body: JSON.stringify({ price: state.price }),
		};

		fetch("/api/495e843c2f424afa9c3c4a3f0e6b6753/" + state.uid, requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						switch (mode) {
							case "A":
								window.location.href = "/newdeala/" + upperState.uid + "/3";
								break;
							case "V":
								window.location.href = "/newdealv/" + upperState.uid + "/3";
								break;
						}
						break;
					case "err":
						break;
					default:
						break;
				}
			});
	};
	useEffect(() => {
		const requestOptions = {
			method: "GET",
			headers: { "Content-Type": "application/json" },
		};
		fetch("/api/finsettings", requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						setState((state) => ({
							...state, settings: res.pld
						}));

						break;
					case "err":
						break;
					default:
						break;
				}
			});
	}, []);
	return (
		<div className={classes.root}>
			<Grid container spacing={1}>
				<Grid item xs={12}>
					<Typography variant="h5">Prix net vendeur</Typography>
				</Grid>
				<Grid item xs={12} >
					<Stack spacing={1} style="max-width: 400px;">
						<NumberField value={state.price > 0 ? state.price : ""} onChange={handleChange} id="price" />
						{state.price > 0 && <div style="margin-top: 30px;">
							<PriceBreakdown2 warning={true} prix_net_vendeur={state.price} settings={state.settings} />
						</div>}
					</Stack>
				</Grid>
			</Grid>
			<Box display="flex" alignItems="center" justifyContent="space-between" style="margin-bottom: 10px; " flexDirection="row">
				<Box></Box>
				<Box>
					<Button
						variant="contained"
						onClick={() => {
							handleSubmit();
						}}
					>
						Valider
					</Button>
				</Box>
			</Box>
		</div >
	);
}
